import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { Mutable } from '@skylab-shared/types';
import { PagedCollectionQuery, PagedCollectionQueryResult } from '../../common/query/paged-collection-query';
import { TaxOfficeCode } from './tax-office.query-base';

export class TaxOfficeQuickListQuery extends PagedCollectionQuery<TaxOfficeCode> { }

export class TaxOfficeQuickListQueryHandlerBase implements QueryHandler<TaxOfficeQuickListQuery, PagedCollectionQueryResult<TaxOfficeCode>> {
    private static Url = TaggedUrl.join('system/taxOffices', [Tags.Api]);
    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(query: TaxOfficeQuickListQuery): Promise<PagedCollectionQueryResult<TaxOfficeCode>> {
        const { data } = await this.http.get<Mutable<PagedCollectionQueryResult<TaxOfficeCode>>>(TaxOfficeQuickListQueryHandlerBase.Url, {
            params: { ...query.params }
        });
        return {
            totalItemsCount: data.totalItemsCount,
            items: data.items.map(i => ({
                name: i.name,
                code: i.code
            }))
        };
    }
}
